import React from 'react';
import * as d3 from 'd3';

class ChartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.props.draw(this.getChart());
    }

    componentDidUpdate() {
        if (this.props.update && !this.props.isUpdateDisabled) {
            this.props.update(this.getChart());
        }
    }

    destroyChart() {
        let chart = this.getChart();
        chart.remove();
        return Promise.resolve();
    }

    getChart() {
        if (!this.props.useRef) {
            return d3.select(this.ref.current);
        }
        return this.ref.current;
    }

    render() {
        return (
            <g
                ref={this.ref}
                style={this.props.style}
            />
        );
    }
}

export default ChartComponent;
